import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { History } from 'history';

import { notificationsReducer } from 'state/notifications';
import { signUpStepsReducer } from 'state/signUpSteps';
import { signInReducer } from 'state/signIn';
import { countryCodesReducer } from 'state/countryCodes';

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// we're intentionally inferring RootState
const createRootReducer = (history: History) =>
  combineReducers({
    router: connectRouter(history),
    notifications: notificationsReducer,
    signUpSteps: signUpStepsReducer,
    signIn: signInReducer,
    countryCodes: countryCodesReducer,
  });

export type RootState = ReturnType<ReturnType<typeof createRootReducer>>;

export default createRootReducer;
